import CustomDialog from '@components/CustomDialog';

type FilterWarningDialogProps = { filternames: string[]; open: boolean; closeHandler: () => void };

const FilterWarningDialog = ({
  open = false,
  closeHandler,
  filternames,
}: FilterWarningDialogProps) => {
  const handleDialogSuccess = async () => {
    closeHandler();
  };

  return (
    <CustomDialog
      opendialog={open}
      dialogTitle={'Warning!'}
      handleSuccess={handleDialogSuccess}
      btnSuccessText="OK"
      dialogTestIdSuffix="FilterWarningDialog"
    >
      <p style={{ marginBottom: 0, color: 'rgba(0, 0, 0, 0.87)' }}>
        This search was created using values that no longer exist or are unavailable.
        <br />
        Please review and adjust the following filter(s) before running the search:
      </p>
      <ul>
        {filternames.map((filtername, index) => {
          return <li key={index}>{filtername}</li>;
        })}
      </ul>
    </CustomDialog>
  );
};

export default FilterWarningDialog;
